/**
 * The canonical checkmark glyph shared by selection controls: the tile
 * indicator disc (TileCheckboxGroup) and the styled Checkbox box. Distinct
 * from the circled `CheckIcon` exported by `@ui/components/Icon` (check.svg).
 */
export function CheckIcon({ className }: { className?: string }) {
  return (
    <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 14 14">
      <path
        d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
